import { React, useState } from "react";
import MenuBar from "../menubar/menubar";
// import login from "../../page/Login/login";
// import Issuebook from "../../page/IssueBook/IssueBook";
// import Manage_Book from "../../page/manage_book/ManageBook";
// import Managerack from "../../page/manage_rack/managerack";
// import Import_books from "../../page/import_books_excel/import_books";
// import Allbook from "../../page/All_book/All_book";
// import Not_return_book from "../../page/return_book/return_book";
// import Upcoming_books_return from "../../page/upcoming_book_return/upcoming_book_return";
// import Department from "../../page/manage_dept/Department";
// import Subdepartment from "../../page/Sub_department/Sub_dept";
// import ShareBooksWithoutSummary from "../../page/book_template/Share_books_Without_Summary";
// import Book_template_without_summary from "../../page/book_template/Book_template_without_summary";
// import Book_template from "../../page/book_template/book_template";

import style from "./layout.module.css";
import {
  BrowserRouter as Routes,
  // Switch,
  // Route,
  // Link,
  Outlet,
} from "react-router-dom";
// import RackList from "../../page/manage_rack/racklist";
// import Testing2 from "../../page/manage_book/Testing2";
// import Share_Books from "../../page/book_template/Share_Books";
// import Users from "../../page/Users/Users";
// import UserForm from "../../page/Users/UserForm";

const Layout = () => {
  const [update, setupdate] = useState(Date.now());
  return (
    <>
      <div className={style.headers}>
        <h3 className={style.heading_title}>Library Manangement System</h3>
      </div>
      <div className={style.container}>
        <MenuBar setupdate={setupdate} />

        <div className={style.content}>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Layout;
